import React, { createContext, useEffect, useState } from "react";
import apiKeyCloak from "./../services/api-keycloak";
import api from "./../services/api";
import Parameter from "./../services/parameter";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";

const Context = createContext({
  authenticated: null,
  HandleLogin: () => null,
  HandleLogout: () => null,
  isLoading: false,
  pageLimit: 50,
  loadingOverlayActive: false,
  loadingOverlayText: "Aguarde...",
});

function Provider({ children }) {
  const [authenticated, setAuthenticated] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [pageLimit, setPageLimit] = useState(50);
  const [loadingOverlayActive, setLoadingOverlayActive] = useState(false);
  const [loadingOverlayText, setLoadingOverlayText] = useState("Aguarde...");

  useEffect(() => {
    const tokenData = JSON.parse(localStorage.getItem("tokenData") || "{}");

    if (tokenData && tokenData.access_token) {
      apiKeyCloak.defaults.headers.Authorization = `Bearer ${tokenData.access_token}`;
      api.defaults.headers.Authorization =
        tokenData.access_token !== undefined
          ? `Bearer ${tokenData.access_token}`
          : "";
      setAuthenticated(true);
    } else {
      apiKeyCloak.defaults.headers.Authorization = "";
      api.defaults.headers.Authorization = "";
      setAuthenticated(false);
    }

    Parameter.defaultPageLimit()
      .then(async (ev) => {
        const data = ev?.data;
        if (data) {
          setPageLimit(data);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar o tamanho de paginação padrão.");
        }
      });
  }, []);

  function HandleLogin(tokenData, cpf) {
    if (tokenData === undefined) return;

    localStorage.setItem("tokenData", JSON.stringify(tokenData));
    localStorage.setItem(
      "user",
      JSON.stringify(jwt_decode(tokenData.access_token))
    );

    apiKeyCloak.defaults.headers.Authorization = `Bearer ${tokenData.access_token}`;
    api.defaults.headers.Authorization = `Bearer ${tokenData.access_token}`;

    setAuthenticated(true);
  }

  function HandleLogout(tokenData) {
    localStorage.setItem("user", "{}");
    localStorage.setItem("tokenData", "{}");
    localStorage.setItem("company", "{}");

    apiKeyCloak.defaults.headers.Authorization = "";
    api.defaults.headers.Authorization = "";
    setAuthenticated(false);
  }

  return (
    <Context.Provider
      value={{
        authenticated,
        HandleLogin,
        HandleLogout,
        isLoading,
        setIsLoading,
        pageLimit,
        setPageLimit,
        loadingOverlayActive,
        setLoadingOverlayActive,
        loadingOverlayText,
        setLoadingOverlayText,
      }}
    >
      <div>{children}</div>
    </Context.Provider>
  );
}

export { Context, Provider };
